import { Salutation } from '@/api/customers'

/**
 * Written out rather than built as `customers.salutation.${value}`: the catalogue keys are typed,
 * so a value without a translation fails the build instead of rendering its key.
 */
export const SALUTATION_LABEL_KEYS = {
  [Salutation.MR]: 'customers.salutation.MR',
  [Salutation.MS]: 'customers.salutation.MS',
  [Salutation.NONE]: 'customers.salutation.NONE',
} as const
